import * as Yup from 'yup';

export interface AddMerchFormValues {
  name: string;
  description: string;
  category: string;
  agency: string;
  image?: File | null;
}

export const createValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must not exceed 100 characters'),
  description: Yup.string()
    .required('Description is required')
    .min(2, 'Description must be at least 2 characters')
    .max(100, 'Description must not exceed 100 characters'),
  image: Yup.mixed()
    .required('Image is required')
    .test('is-file', 'Image must be a file', (value) => {
      return value instanceof File || value === null;
    })
    .test('is-image', 'File must be an image', (value) => {
      if (!value) return true;
      return value instanceof File && value.type.startsWith('image/');
    }),
  category: Yup.string().required('Category is required'),
  agency: Yup.string().required('Agency is required'),
});

export const updateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must not exceed 100 characters'),
  description: Yup.string()
    .required('Description is required')
    .min(2, 'Description must be at least 2 characters')
    .max(100, 'Description must not exceed 100 characters'),
  image: Yup.mixed()
    .nullable()
    .test('is-image', 'File must be an image', (value) => {
      if (!value) return true;
      return value instanceof File && value.type.startsWith('image/');
    }),
  category: Yup.string().required('Category is required'),
  agency: Yup.string().required('Agency is required'),
});

export const validationSchema = createValidationSchema;

export const defaultValues: AddMerchFormValues = {
  name: '',
  description: '',
  category: '',
  agency: '',
  image: null,
};
